import { toast } from "react-toastify";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { _single, _SpareInventoried } from "../../../../../core/services/dataBean/EntityCatalog";
import { useEffect, useState } from "react";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { BasicTable } from "../../../../theme/Component/BasicTable";
import { Modal } from "../../../../theme/Component/Modal";
import { EditorFixedAssetItem } from "../../../../contract/etapa-contrato/contrac/ublinvoice/FixedAssetItem/EditorFixedAssetItem";
import { SelectConstantsValue } from "../../../../theme/Component/SelectConstantsValue";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
import { FileInput } from "../../../../theme/Component/FileInput";
import useModal, { MODAL_md } from "../../../../theme/Component/hooks/useModal";
import { ImportXLSX } from "../../../../theme/Component/ImportXLSX";

interface Form {
    State: number;
    Location: number;
}

interface Props {
    spareType: any;
}

export const SpareInventoried = ({ spareType }: Props) => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_SpareInventoried);
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: 'Eliminar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [spareType])

    const getLista = () => {
        const props = {
            IDSpareInventoriedType: spareType.IDSpareInventoriedType
        }
        instance.getSpareInventoriedCatalogPorPropiedades(props, null).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        ).catch(err => { toast.error(err) })
    }

    const create = () => {
        setBean({
            IDSpareInventoriedType: spareType.IDSpareInventoriedType,
            State: 1,
            IDEmployee: _single.getAccountID(),
        });
        setModal({ ...modal, "name": `Agregar Objeto de Mantenimiento`, "view": true });
    }

    const deleteItem = () => {
        const x = { ...bean, State: 3 };
        editaItem(x);
        setModalC({ ...modalC, view: false });
    };

    const editaItem = (obj: any) => {
        instance.updateSpareInventoried(obj).then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })
    }

    const head = [
        { title: 'ID', property: 'IDSpareInventoried', visible: true },
        { title: 'Codigo', property: 'CodeInventoried', visible: true },
        { title: 'Nombre', property: 'IDItemName', visible: true },
        { title: 'Ubicación', property: 'IDLocationName', visible: true },
        { title: 'Utilidades', property: 'ItemUtilities', visible: true },
        { title: 'Cantidad Disponible', property: 'TotalQuantity', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create },
        { nombre: 'Importar Items', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: () => { modalImport.open() } }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar`, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const modalImport = useModal("Importar", MODAL_md);
    const [listImport, setListImport] = useState([]);


    const importMenu = async () => {
        console.log(listImport);
        let existe: string[] = [];
        let errores: number[] = [];

        lista.forEach(element => {
            const code = element.DataBeanProperties.CodeInventoried;
            if (code && typeof code === "string") {
                existe.push(code.trim());
            }

        });

        for (let index = 1; index < listImport.length; index++) {
            let row = listImport[index];

            const idItem = row[0];
            const description = row[1];

            if (!idItem || !description) {
                toast.warning(`Falta IDItem o Descripción en la fila ${index + 1}`);
                errores.push(index + 1);
                continue;
            }

            if (!existe.includes(row[2])) {
                let obj = {
                    IDItem: row[0],
                    IDItemName: row[1],
                    CodeInventoried: row[2],
                    TotalQuantity: row[3],
                    ItemUtilities: row[4],
                    IDSpareInventoriedType: spareType.IDSpareInventoriedType,
                    State: 1,
                    IDEmployee: _single.getAccountID(),
                };

                try {
                    await instance.updateSpareInventoried(obj).then(
                        (resp) => {
                            toast.success(`Objeto de Inventario creado en la fila ${index + 1}`)
                        }
                    )
                } catch (err) {
                    console.log(`Error en la fila ${index}:`, err);
                    toast.error(`Error al crear el item en la fila ${index}`);
                    errores.push(index);
                }
            }
        }

        // fin del proceso

        await getLista();

        setModal({ ...modal, "view": false });

        modalImport.close();

        if (errores.length > 0) {
            alert(`Error en los siguientes índices: ${errores.join(", ")}`);
        }
    };


    //     PNG: image/png 
    //     GIF: image/gif
    //     BMP: image/bmp
    //     TIFF: image/tiff
    //     SVG: image/svg+xml

    return (
        <div className="row">
            <div className="col-md-12">
                <BasicTable body={lista} head={head} rowSet={setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem} />

                <Modal modal={modal} updateModal={setModal} eventModal={() => { editaItem(bean) }}>
                    <div className="row">
                        <div className="col-md-12">
                            <FileInput
                                previsualization
                                Media={bean.MediaIMG}
                                MediaContext={bean.MediaContextIMG}
                                docAcept="image/jpeg, image/png, image/gif, image/bmp, image/tiff, image/svg+xml"
                                onCreate={(e) => { setBean({ ...bean, MediaIMG: e.Media, MediaContextIMG: e.MediaContext }) }}
                            />
                        </div>
                        <div className="col-md-6">
                            <EditorFixedAssetItem idSelector={bean.IDItem} label="Item de Mantenimiento" onChange={(e) => { setBean({ ...bean, IDItem: e.IDItem, IDItemName: e.Name }) }} />
                        </div>
                        <div className="col-md-6">
                            <label>Codigo Interno</label>
                            <input type="text" className="form-control" value={bean.CodeInventoried} onChange={(e) => { setBean({ ...bean, CodeInventoried: e.target.value }) }} />
                        </div>
                        <div className="col-md-6">
                            <SelectConstantsValue
                                returnType="Object"
                                label="Ubicación de Almacenamiento"
                                code={27}
                                onChange={(e: any) => { setBean({ ...bean, IDLocation: e?.CodeID, IDLocationName: e?.Name }) }}
                                value={bean.IDLocation}
                            />
                        </div>
                        <div className="col-md-6">
                            <label>Cantidad Exixstente</label>
                            <input type="number" className="form-control" value={bean.TotalQuantity} onChange={(e) => { setBean({ ...bean, TotalQuantity: e.target.value }) }} />
                        </div>
                        <div className="col-md-12">
                            <label >Utilidades</label>
                            <textarea className="form-control" value={bean.ItemUtilities} onChange={(e) => { setBean({ ...bean, ItemUtilities: e.target.value }) }} />
                        </div>
                    </div>
                </Modal>

                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                    <strong>Eliminar item {bean.Description}</strong>
                </ModalConfirm>

                <Modal modal={modalImport.modal} updateModal={modalImport.setModal} eventModal={importMenu} onSubmitLabel="Importar">
                    <div className="row">
                        <div className="col">
                            <ImportXLSX lodaData={setListImport} />
                        </div>
                    </div>
                </Modal>
            </div>

        </div>
    )
}